/**
 * Portal Manta · PagesSidebar
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { NAV } from '../../globals.js';

function PagesSidebar({page,onPage,modo,focus}){
  if(modo!=='lote') return null; // Em modo estudo, não mostra páginas do lote
  if(focus){
    // Em modo foco, esconde a sidebar de páginas — usuário já está vendo os dados
    return null;
  }
  return(<div style={{width:170,background:'#1A2840',borderRight:'1px solid rgba(255,255,255,.06)',display:'flex',flexDirection:'column',flexShrink:0}}>
    <div style={{padding:'10px 12px',borderBottom:'1px solid rgba(255,255,255,.08)',fontSize:9,fontWeight:700,color:'rgba(255,255,255,.4)',letterSpacing:'.12em',textTransform:'uppercase'}}>Análise do Lote</div>
    <div style={{padding:'8px 7px'}}>
      {NAV.map((n,i)=>(<div key={n.k} onClick={()=>onPage(n.k)} style={{
        display:'flex',alignItems:'center',gap:6,
        padding:'7px 9px',borderRadius:6,
        fontSize:10.5,
        color:page===n.k?'#F4A76A':'rgba(255,255,255,.55)',
        fontWeight:page===n.k?600:400,
        background:page===n.k?'rgba(212,104,42,.2)':'transparent',
        borderLeft:page===n.k?'2px solid #D4682A':'2px solid transparent',
        cursor:'pointer',marginBottom:1,transition:'all .11s',
      }} onMouseEnter={e=>{if(page!==n.k){e.currentTarget.style.background='rgba(255,255,255,.06)';e.currentTarget.style.color='rgba(255,255,255,.85)';}}} onMouseLeave={e=>{if(page!==n.k){e.currentTarget.style.background='transparent';e.currentTarget.style.color='rgba(255,255,255,.55)';}}}>

        <span style={{fontSize:9}}>{n.icon}</span>{i+1}. {n.label}
      </div>))}
    </div>
  </div>);
}

export { PagesSidebar };
export default PagesSidebar;
